import * as yup from 'yup';
import { TFunction } from 'i18next';

export interface NotesAndEndorsementsFormValues {
  notesAndEndorsements?: string;
}

export const getInitialValues = (): NotesAndEndorsementsFormValues => ({
  notesAndEndorsements: '',
});

export const getInitialNotesAndEndorsements = (
  contract?: any
): NotesAndEndorsementsFormValues => {
  return {
    notesAndEndorsements: contract?.notesAndEndorsements || '',
  };
};

export const getNotesAndEndorsementsValidationSchemaShape = (t: TFunction) => ({
  notesAndEndorsements: yup.string().optional(),
});

export const shouldShowNotesAndEndorsements = (
  contractStatus?: string
): boolean => {
  return true;
};
